import React from "react"
import Style from "../styles/content.module.css"

export default ({children}) => (
    <div className={Style.box}>
        {children}
    </div>
)